export default __webpack_public_path__ + "static/media/oldtown.b2bec5c4.jpg";